import { useState, useRef, forwardRef, useImperativeHandle, memo, useEffect } from 'react';
import Button from '@mui/material/Button';
import {
    Box,
    Grid2 as Grid,
    DialogTitle,
    Tooltip,
    ButtonGroup,
    Chip
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';




import { globalstyles } from '../lib/definitions';
import { myTimestampToDate, propComparator, getSelectedElement, propComparatorDate } from '../utils/ui_utils';
import { format, differenceInMonths } from 'date-fns';
import { AddBox, CheckBox, CheckBoxOutlineBlank, Close, Delete, FactCheck, Info, LibraryAddCheck, PictureAsPdf, Save, ViewList, Warning } from '@mui/icons-material';
import _ from 'lodash';
import { useEvent } from '../context/eventContext';
import { PublicCowDialog } from './PublicCowDialog';
import { PresenceIcon, PresenceSummary, TogglePresenceButton } from '../components/PresenceButton';
import { PropertyLabel } from '../definitions/property';
import { CowtypeBadge } from '../components/CowtypeButton';
import { CowcategoryListBadge } from '../components/CowcategoryListBadge';
import { CowtypeListBadge } from '../components/CowtypeListBadge';
import { ContainerPdfDialog } from './PdfContainerDialog';
import { get_Property_list } from '../FirebaseUtils/dbProperty';
import GroupPageMenu from '../components/menu/GrouppageMenu';
import { getSummaryData } from '../definitions/cow';


const groupby_mode_dict = {
    prov: { id: 'prov', label: 'provincia', title: 'soggetti raggruppati per provincia' },
    cowman: { id: 'cowman', label: 'allevatore', title: 'soggetti raggruppati per allevatore' },
    property: { id: 'property', label: 'azienda', title: 'soggetti raggruppati per azienda' },
}

export const CowGroupviewDialog = forwardRef(({ }, ref) => {

    const pdfRef = useRef()
    const publicRef = useRef()
    const [open, setOpen] = useState(false);
    const [cow_list, setCowList] = useState([])
    const [showEmpty, setShowEmpty] = useState(false)
    const [showNotPresent, setShowNotPresent] = useState(false)
    const [groupMode, setGroupMode] = useState('prov')
    const [viewData, setViewData] = useState([])


    useImperativeHandle(ref, () => {
        return {
            onOpen(cl) {
                setOpen(true);
                setCowList(cl)
                initData(groupMode, cl)
            },
        }
    })

    const handlePdf = async (mode) => {
        pdfRef.current.onOpen({ data_list: viewData.filter(group => showEmpty || group.cow_list.filter(c => c.is_present === true).length > 0), cow_list: cow_list, mode: mode, title: groupby_mode_dict[groupMode].title, showNotPresent: showNotPresent }, groupby_mode_dict[groupMode].title, 'group_print')
    }

    const handleClose = () => {
        setOpen(false);
    };


    useEffect(() => {
        initData(groupMode, cow_list)
    }, [groupMode])

    const handleShow = (c) => {
        publicRef.current.onShow(c)
    }


    const initData = async (gm, cl) => {
        const p_list = getSummaryData(gm, cl)
        setViewData(p_list)
    }


    const MyContent = () => {
        return (
            <>
                <Grid container flexDirection={"column"} >

                    {viewData.length > 0 ?
                        <>
                            {viewData.map((g, k) => (
                                <OneGroupedData
                                    group={g}
                                    key={k}
                                    index={k}
                                    showEmpty={showEmpty}
                                    showNotPresent={showNotPresent}
                                    handleShow={handleShow}
                                />
                            ))}
                        </>
                        : <>
                            Nessun soggetto presente
                        </>}
                </Grid>
            </>
        )
    }


    return (


        <Dialog open={open} onClose={handleClose} maxWidth="md" fullScreen={true}>
            <ContainerPdfDialog ref={pdfRef} />
            <PublicCowDialog ref={publicRef} />
            <DialogTitle>
                <Grid container>
                    <Grid size="grow" container alignItems={"center"}>
                        Lista soggetti: <Chip size="small" color="primary" label={<>{cow_list.length} soggetti</>} />
                        <Grid size={"auto"} style={{ background: 'white', paddingLeft: 4, paddingRight: 4 }} container alignItems={"center"}>
                            <PresenceSummary element_list={cow_list} />
                            <Box style={{ fontSize: '0.8em' }}>
                                <CowcategoryListBadge cow_list={showNotPresent ? cow_list : cow_list.filter(c => c.is_present === true)} />
                                <CowtypeListBadge cow_list={showNotPresent ? cow_list : cow_list.filter(c => c.is_present === true)} />
                            </Box>
                        </Grid>
                    </Grid>
                    <Grid size="auto">
                    </Grid>
                    <Grid size="auto" style={{ textAlign: 'right' }}>
                        <ButtonGroup size="small">
                            {Object.values(groupby_mode_dict).map((g, k) => (
                                <Button color="secondary" key={k} variant={groupMode === g.id ? "contained" : "outlined"} onClick={() => setGroupMode(g.id)}>{g.label} {groupMode === g.id ? `(${viewData.length})` : ''}</Button>
                            ))}
                            <GroupPageMenu handlePdf={handlePdf} setShowNotPresent={setShowNotPresent} showNotPresent={showNotPresent} setShowEmpty={setShowEmpty} showEmpty={showEmpty} />
                        </ButtonGroup>
                    </Grid>
                </Grid>
                {cow_list.length > 0 &&
                    <Grid container sx={globalstyles.listHeader}>
                        <Grid size={1}>
                            Catalogo
                        </Grid>
                        <Grid size={1}>
                            Matricola
                        </Grid>
                        <Grid size="grow">
                            Nome
                        </Grid>
                        <Grid size="grow">
                            Proprietà
                        </Grid>
                        <Grid size={1}>
                            Parti
                        </Grid>
                        <Grid size={1}>
                            Età (mesi)
                        </Grid>
                        <Grid size={1}>
                            Data di nascita
                        </Grid>
                        <Grid size={0.8}>
                        </Grid>
                    </Grid>
                }
            </DialogTitle>
            <DialogContent>
                <MyContent />
            </DialogContent>
            <DialogActions>
                <ButtonGroup>
                    <Button variant='outlined' key={'bc'} onClick={handleClose} startIcon={<Close />}>Chiudi</Button>
                </ButtonGroup>
            </DialogActions>
        </Dialog>

    )

})


const OneGroupedData = memo(({ group, showNotPresent, handleShow, showEmpty }) => {
    const cow_list = showNotPresent ? group.cow_list : group.cow_list.filter(c => c.is_present === true)
    const selEvent = useEvent()
    if (showEmpty || cow_list.length > 0) {
        console.log("SELEVENT", selEvent)

        return (
            <>
                <Grid container sx={{ ...globalstyles.sectionHeader, mt: 1 }}>
                    <Grid size={"grow"}>
                        {group.cdaua_cowman || group.cdaua}&nbsp;
                        {group.name}
                    </Grid>
                    <Grid size={"auto"} style={{ background: 'white', paddingLeft: 4, paddingRight: 4 }}>
                        <Chip size="small" color="primary" label={<>{group.cow_list.length} soggetti</>} />
                    </Grid>
                    <Grid size={"auto"} style={{ background: 'white', paddingLeft: 4, paddingRight: 4 }}>
                        <PresenceSummary element_list={group.cow_list} />
                    </Grid>
                    <Grid size={"auto"} style={{ background: 'white', paddingLeft: 4, paddingRight: 4 }}>
                        <CowcategoryListBadge cow_list={cow_list} old_cow_cat={selEvent.selEvent.old_cow_first_category} />
                    </Grid>
                    <Grid size={"auto"} style={{ background: 'white', paddingLeft: 4, paddingRight: 4 }}>
                        <CowtypeListBadge cow_list={cow_list} />
                    </Grid>
                </Grid>
                {cow_list.map((c, ck) => (
                    <OneCow cow={c} key={ck} index={ck} handleShow={handleShow} />
                ))}
            </>
        )
    } else {
        return (
            <></>
        )
    }
})


const OneCow = memo(({ cow, handleShow }) => {
    const birthdate = myTimestampToDate(cow.birthdate)

    return (
        <Grid container sx={{ ...globalstyles.list_row, ...globalstyles.elem_row, fontSize: '0.7em' }}>
            <Grid size={0.5}>
                {cow.catalog_id}
            </Grid>
            <Grid size={1} flexDirection={"row"} container>
                <CowtypeBadge cow_type={cow.cow_type} />
                {cow.serial}
            </Grid>
            <Grid size="grow">
                {cow.name}
            </Grid>
            <Grid size="grow">
                {cow.property &&
                    <PropertyLabel element={cow.property} />
                }
            </Grid>
            <Grid size={1}>
                {cow.birth}
            </Grid>
            <Grid size={1}>
                {differenceInMonths(new Date(), birthdate)}
            </Grid>
            <Grid size={1}>
                {format(birthdate, 'dd/MM/yyyy')}
            </Grid>
            <Grid size={0.8} >
                <ButtonGroup size="small" >
                    <PresenceIcon is_present={cow.is_present} />
                    <Button size="small" variant="outlined" onClick={() => handleShow(cow)}><Info sx={{ fontSize: '1.2em' }} /></Button>
                </ButtonGroup>
            </Grid>
        </Grid>
    )

})
